import React from 'react';
import { Icon } from './Icon.js';
export const IconFolderUpload = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M18 13.793L18 13.25L18 21.25", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M14.5 16.75L18 13.25L21.5 16.75", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M13.4141 5H23V14.0098L21 12.0098V7H12.5859L9.58594 4H3V19H12V21H1V2H10.4141L13.4141 5Z", fill: "currentColor", "data-color": "color-2", "data-stroke": "none" })));
};
//# sourceMappingURL=IconFolderUpload.js.map